import Alpine from 'alpinejs';

export default function productModal() {
    document.addEventListener('alpine:init', () => {
        Alpine.data('productModal', () => ({
            init(){
                this.$watch('quantity', (new_value) => {

                    if (new_value > (this.product.stock_maximum_order ?? 100000)){

                        this.quantity = this.product.stock_maximum_order;

                    } else if (new_value < 1){

                        this.quantity = 1;

                    }

                });
            },
            product: Alpine.store('product') ?? {},
            setProduct: function(param) {

                const product = param.detail.product;

                if (product.parent_id){
                    this.product = product;
                }else{
                    Alpine.store('product', product);
                }
            },
            quantity: 1,
            isSubmitButtonDisabled: (product) => {

                return !product.is_active || product.stock === 0;

            },
            translate: (obj) => {
                return App.prototype.translateAttribute(obj)
            },
            formatPrice: (price, symbol) => {
                return App.prototype.currencyFormat(price) + ' ' + symbol
            },
            quantityCounter: (max) => {
                console.log('max', max, this.quantity);
            },
        }));
    })
}
